module.exports = __webpack_public_path__ + "static/media/phai-sinh-hang-hoa.239f43d8.jpg";